export default {"src":"/_next/static/media/nerd-own.bccb0948.svg","height":100,"width":100};